import { isDev } from "./host";

export default {
  Auth: {
    Cognito: {
      userPoolId: isDev ? "eu-west-1_QPtu8TbsN" : "eu-west-1_GRBRFKqCc",
      userPoolClientId: isDev ? "4culqf885lnfb51uel7cia82ie" : "51qhi4os82uroccd7pa49coi72",
    },
  },
};
